import React from 'react';

const Recommendations = ({ overallRecommendations, keyStrengths, areasForImprovement, keyAreasForImprovement }) => {
  // Support both keyAreasForImprovement (new) and areasForImprovement (legacy)
  const improvementAreas = keyAreasForImprovement || areasForImprovement;
  // Format the overallRecommendations text to preserve line breaks
  const formatText = (text) => {
    if (!text) return '';
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <div className="m-6 p-0">
      {overallRecommendations && (
        <div className="p-6 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800 border-t-4 border-t-blue-600">
          <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-200 dark:border-gray-600">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center text-xl font-bold text-white bg-blue-600 shrink-0">📋</div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white m-0">Overall Recommendations</h3>
          </div>
          <div className="text-gray-700 dark:text-gray-300 leading-relaxed text-base whitespace-pre-wrap">
            {formatText(overallRecommendations)}
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        {keyStrengths && keyStrengths.length > 0 && (
          <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800 border-t-4 border-t-green-500">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-200 dark:border-gray-600">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-xl font-bold text-white bg-green-500 shrink-0">✓</div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white m-0">Key Strengths</h3>
            </div>
            <ul className="list-none p-0 m-0">
              {keyStrengths.map((item, index) => (
                <li key={index} className="flex items-start gap-3 py-3 border-b border-gray-100 dark:border-gray-600 last:border-b-0 text-gray-700 dark:text-gray-300 leading-relaxed">
                  <span className="text-green-500 text-xl font-bold shrink-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {improvementAreas && improvementAreas.length > 0 && (
          <div className="p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800 border-t-4 border-t-amber-500">
            <div className="flex items-center gap-3 mb-5 pb-4 border-b border-gray-200 dark:border-gray-600">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-xl font-bold text-white bg-amber-500 shrink-0">→</div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white m-0">Areas for Production Enhancement</h3>
            </div>
            <ul className="list-none p-0 m-0">
              {improvementAreas.map((item, index) => (
                <li key={index} className="flex items-start gap-3 py-3 border-b border-gray-100 dark:border-gray-600 last:border-b-0 text-gray-700 dark:text-gray-300 leading-relaxed">
                  <span className="text-amber-500 text-xl font-bold shrink-0">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default Recommendations;

